import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { take } from 'rxjs';

import { LoggerService, StaticsService } from '@app/services';
import { MenuItem } from '@core/entities';
import { IMenuItem } from '@core/types';
import { LoadingService } from '@services/loading/loading.service';
import { LoadingComponent } from '@components/loading/loading.component';
import { IonApp, IonRouterOutlet } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['app.component.scss'],
  imports: [IonApp, IonRouterOutlet],
})
export class AppComponent implements OnInit {
  appPages: MenuItem[];

  labels = ['Family', 'Friends', 'Notes', 'Work', 'Travel', 'Reminders'];
  constructor(
    private staticsService: StaticsService,
    private loggerService: LoggerService
  ) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    return this.staticsService
      .findMenus()
      .pipe(take(1))
      .subscribe({
        next: (res) => {
          this.appPages = res.map((item: IMenuItem) => new MenuItem(item));

          this.loggerService.log('Data loaded successfully', this.appPages);
          return this.appPages;
        },
        error: (err) => this.loggerService.error('Error loading data', err),
      });
  }
}
